import React from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight, FaCloud, FaLaptop, FaWrench, FaShieldAlt,
  FaServer, FaCode, FaNetworkWired, FaUserTie, FaDesktop,
  FaChartBar, FaPlusSquare, FaCubes, FaChartLine, FaDatabase,
  FaPuzzlePiece, FaStar, FaLock, FaHeadset,
} from "react-icons/fa";
import Sliderhome from "../inc/Sliderhome";
import Logistic   from "../inc/Logistic";
import VMC        from "./inc/Vmc";
import WhatsApp   from "../inc/Whatsapp";
import Services5  from "../images/d7.png";
import Services6  from "../images/d8.png";
import Services7  from "../images/d9.jpg";
import Services8  from "../images/d10.png";
import Services14 from "../images/t14.jpg";
import Services15 from "../images/t15.jpg";
import Services18 from "../images/t16.jpg";
import bgImage    from "../images/t17.jpg";
import isoLogo    from "../images/q1.jpg";
import gdprLogo   from "../images/q2.png";
import pciLogo    from "../images/q3.png";

/* ─────────────────────────────────────────────────────────────
   Brand constant — update once, reflected everywhere
───────────────────────────────────────────────────────────── */
const COMPANY = "Skywise Technologies";

/* ─────────────────────────────────────────────────────────────
   Data
───────────────────────────────────────────────────────────── */
const SERVICES = [
  { id: "s1", icon: <FaCloud />,     title: "Cloud Solutions",        desc: "Tailored cloud solutions that align with your business objectives, improving efficiency and scalability.",                   bg: "#dbeafe" },
  { id: "s2", icon: <FaLaptop />,    title: "Modern Workplace",       desc: "Enable modern workplace transformation, leveraging cloud technology for enhanced collaboration and productivity.",           bg: "#fef2f2" },
  { id: "s3", icon: <FaWrench />,    title: "24×7 Managed Services",  desc: "Round-the-clock managed services to ensure smooth and uninterrupted cloud operations for your business.",                   bg: "#fef2f2" },
  { id: "s4", icon: <FaShieldAlt />, title: "Cyber Security",         desc: "We prioritise security in every aspect of our cloud services, ensuring your data and applications are always protected.",   bg: "#f3f4f6" },
  { id: "s5", icon: <FaServer />,    title: "Infrastructure Services", desc: "From planning and design to deployment, we ensure your IT infrastructure aligns with your business objectives.",            bg: "#eff6ff" },
  { id: "s6", icon: <FaCode />,      title: "Business Applications",  desc: "We design and develop high-performing applications optimised for cloud, driving business transformation.",                  bg: "#fef2f2" },
];

const SAAS_ITEMS = [
  { id: "sa1", icon: <FaNetworkWired />, title: "Business Process Management", desc: "Discover, model, analyse, measure, improve, optimise and automate business processes across your organisation."       },
  { id: "sa2", icon: <FaUserTie />,      title: "Cloud-based Services",        desc: "Expert SaaS applications for your business and hands-on help with Virtualisation & Clustering environments."         },
  { id: "sa3", icon: <FaDesktop />,      title: "FOSS",                        desc: "Free and open-source software that maintains user civil liberty rights — fully customised for your specific needs."   },
  { id: "sa4", icon: <FaServer />,       title: "Low Code App Development",    desc: "Create interconnected custom business apps on major cloud platforms without traditional coding skills."              },
  { id: "sa5", icon: <FaChartBar />,     title: "BI and Analytics",            desc: "Solutions across all leading BI tools that transform raw data into meaningful, actionable business intelligence."     },
  { id: "sa6", icon: <FaPlusSquare />,   title: "Enterprise Service Mgmt",     desc: "Implement IT Service Management (ITSM) principles in business processes to improve performance and outcomes."       },
];

const INTEGRATION_BENEFITS = [
  { id: "ib1", icon: <FaCubes />,        title: "Enhanced Business Agility"       },
  { id: "ib2", icon: <FaArrowRight />,   title: "Improved Data Accessibility"     },
  { id: "ib3", icon: <FaChartLine />,    title: "Optimised Resource Utilisation"  },
  { id: "ib4", icon: <FaDatabase />,     title: "Robust Disaster Recovery"        },
  { id: "ib5", icon: <FaPuzzlePiece />,  title: "Seamless System Integration"     },
  { id: "ib6", icon: <FaShieldAlt />,    title: "Enhanced Security Posture"       },
];

const SAAS_BENEFITS = [
  { id: "sb1", title: "Cost Control",       desc: "Choose the most suitable and budget-friendly SaaS solutions for your business size and needs." },
  { id: "sb2", title: "Services Support",   desc: "Continuous support from selection through deployment and ongoing post-deployment usage."        },
  { id: "sb3", title: "Compatibility",      desc: "A solution compatible with your business needs — not the other way around."                    },
  { id: "sb4", title: "Security",           desc: "Solutions with all necessary security certificate credentials and compliance standards."        },
  { id: "sb5", title: "Try Before You Buy", desc: "Free trials of SaaS-based products so you can evaluate how effectively each solution performs." },
];

const VALUE_PILLARS = [
  { id: "vp1", icon: <FaStar />,      title: "Delighting",  accentWord: "Clients",  desc: "Surpassing service expectations with top-notch IT solutions tailored to your exact needs.",        img: Services8 },
  { id: "vp2", icon: <FaChartLine />, title: "Focus on",   accentWord: "Results",  desc: "Concerned with what adds value to your business — creating customised solutions that deliver ROI.", img: Services7 },
  { id: "vp3", icon: <FaLock />,      title: "Data",        accentWord: "Security", desc: "Multiple layers of data protection and encryption that minimise your risk of security exposure.",  img: Services5 },
  { id: "vp4", icon: <FaHeadset />,   title: "User",        accentWord: "Support",  desc: "Constant, superior technical support aimed at ensuring complete and lasting customer satisfaction.", img: Services6 },
];

const CERTS = [
  { id: "c1", src: isoLogo,  alt: "ISO Certified",    maxH: 110 },
  { id: "c2", src: gdprLogo, alt: "GDPR Compliant",   maxH: 90  },
  { id: "c3", src: pciLogo,  alt: "PCI DSS Compliant", maxH: 90  },
];

/* ─────────────────────────────────────────────────────────────
   Component
───────────────────────────────────────────────────────────── */
function Home() {
  return (
    <>
      <style>{`
        :root {
          /* ── Brand palette ── */
          --hm-primary:      #0d3c55;
          --hm-accent:       #007bff;
          --hm-accent2:      #00c2ff;
          --hm-danger:       #dc2626;
          --hm-cyan:         #00bcd4;

          /* ── Surface ── */
          --hm-bg:           #f8fafc;
          --hm-bg-dark:      #0d0a1f;
          --hm-card:         #ffffff;

          /* ── Typography ── */
          --hm-text-dark:    #0f172a;
          --hm-text-body:    #475569;
          --hm-text-muted:   #94a3b8;

          /* ── Misc ── */
          --hm-border:       #e2e8f0;
          --hm-shadow:       0 4px 24px rgba(0,0,0,0.07);
          --hm-shadow-hover: 0 10px 32px rgba(0,0,0,0.13);
          --hm-radius:       14px;

          /* ── Font family — system UI stack (no external download needed) ── */
          --font-display: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
          --font-body:    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
        }

        /* ── Base ── */
        .hm-page { font-family: var(--font-body); background: var(--hm-bg); }

        /* ── Layout helpers ── */
        .hm-container { max-width: 1180px; margin: 0 auto; padding: 0 1.5rem; }
        .hm-section   { padding: 5rem 0; }
        .hm-divider   { border: none; border-top: 1px solid var(--hm-border); margin: 0; }

        /* ── Typography helpers ── */
        .hm-eyebrow {
          font-family: var(--font-body);
          font-size: 0.72rem; font-weight: 700; letter-spacing: 0.14em;
          text-transform: uppercase; color: var(--hm-accent); margin-bottom: 0.4rem;
        }
        .hm-section-title {
          font-family: var(--font-display);
          font-size: clamp(1.6rem, 3vw, 2.2rem);
          font-weight: 600; color: var(--hm-text-dark);
          margin: 0 0 0.4rem; line-height: 1.3;
        }
        .hm-underline {
          width: 48px; height: 3px; background: var(--hm-accent);
          border-radius: 2px; margin-bottom: 1.25rem;
        }
        .hm-section-desc {
          font-family: var(--font-body);
          font-size: 1rem; color: var(--hm-text-body);
          line-height: 1.8; max-width: 680px; margin-bottom: 0;
          font-weight: 400;
        }

        /* ── Buttons ── */
        .hm-btn-primary {
          display: inline-flex; align-items: center; gap: 0.5rem;
          padding: 0.72rem 1.5rem; background: var(--hm-accent);
          color: #fff; border-radius: 8px; font-weight: 600;
          font-size: 0.875rem; text-decoration: none;
          font-family: var(--font-body); border: none; cursor: pointer;
          letter-spacing: 0.01em;
          transition: background 0.2s, box-shadow 0.25s, transform 0.2s;
        }
        .hm-btn-primary:hover {
          background: #0056cc; color: #fff;
          box-shadow: 0 6px 20px rgba(0,123,255,0.3);
          transform: translateY(-2px);
        }
        .hm-btn-outline {
          display: inline-flex; align-items: center; gap: 0.5rem;
          padding: 0.7rem 1.4rem; background: transparent;
          border: 2px solid var(--hm-accent); color: var(--hm-accent);
          border-radius: 8px; font-weight: 600; font-size: 0.875rem;
          text-decoration: none; font-family: var(--font-body);
          letter-spacing: 0.01em;
          transition: background 0.2s, color 0.2s, transform 0.2s;
        }
        .hm-btn-outline:hover {
          background: var(--hm-accent); color: #fff; transform: translateY(-2px);
        }

        /* ── Intro strip ── */
        .hm-intro-strip {
          background: linear-gradient(135deg, #060f24 0%, #0d2352 100%);
          padding: 3rem 1.5rem; text-align: center;
        }
        .hm-intro-strip h2 {
          font-family: var(--font-display);
          font-size: clamp(1.3rem, 3vw, 1.9rem);
          font-weight: 600; color: #f0b429; margin-bottom: 0.6rem;
          line-height: 1.3;
        }
        .hm-intro-strip p {
          font-family: var(--font-body);
          font-size: 1rem; color: rgba(255,255,255,0.72);
          margin: 0 auto; max-width: 660px; font-weight: 400; line-height: 1.75;
        }

        /* ── Two-col split ── */
        .hm-split { display: flex; flex-wrap: wrap; align-items: center; gap: 3rem; }
        .hm-split.reverse { flex-direction: row-reverse; }
        .hm-split-text { flex: 1 1 300px; }
        .hm-split-img  { flex: 1 1 300px; display: flex; justify-content: center; }
        .hm-split-img img {
          width: 100%; max-width: 460px; height: auto;
          border-radius: var(--hm-radius);
          box-shadow: var(--hm-shadow-hover);
          object-fit: cover;
          transition: transform 0.35s ease;
        }
        .hm-split-img img:hover { transform: scale(1.03); }

        /* ── Purpose band ── */
        .hm-purpose {
          position: relative; min-height: 280px;
          background-size: cover; background-position: center;
          display: flex; align-items: center;
        }
        .hm-purpose-overlay {
          position: absolute; inset: 0;
          background: linear-gradient(105deg, rgba(6,15,36,0.9) 0%, rgba(13,35,82,0.75) 100%);
        }
        .hm-purpose-inner {
          position: relative; z-index: 1;
          padding: 4rem 1.5rem; max-width: 1180px; margin: 0 auto; width: 100%;
        }
        .hm-purpose-inner h2 {
          font-family: var(--font-display);
          font-size: clamp(1.5rem, 3.5vw, 2.2rem);
          font-weight: 600; color: var(--hm-accent2);
          margin-bottom: 1rem;
        }
        .hm-purpose-inner p {
          font-family: var(--font-body);
          font-size: 1.05rem; color: rgba(255,255,255,0.78);
          max-width: 640px; line-height: 1.8; margin: 0; font-weight: 400;
        }

        /* ── Integration grid ── */
        .hm-int-grid {
          display: grid; grid-template-columns: repeat(3,1fr);
          gap: 1rem; margin-top: 1.5rem;
        }
        .hm-int-card {
          display: flex; align-items: center; gap: 0.9rem;
          padding: 1.1rem 1.25rem; border-radius: 10px;
          border: 1.5px solid var(--hm-border); background: var(--hm-card);
          transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
        }
        .hm-int-card:hover {
          border-color: var(--hm-accent); transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(0,123,255,0.12);
        }
        .hm-int-icon {
          width: 40px; height: 40px; border-radius: 8px; flex-shrink: 0;
          background: rgba(0,123,255,0.08); border: 1px solid rgba(0,123,255,0.18);
          color: var(--hm-accent); display: flex; align-items: center;
          justify-content: center; font-size: 0.95rem;
        }
        .hm-int-card h6 {
          font-family: var(--font-body);
          font-size: 0.875rem; font-weight: 600;
          color: var(--hm-text-dark); margin: 0;
        }

        /* ── Services grid ── */
        .hm-services-grid {
          display: grid; grid-template-columns: repeat(3,1fr);
          gap: 1.25rem; margin-top: 2rem;
        }
        .hm-service-card {
          border-radius: 12px; padding: 1.75rem 1.5rem;
          border: 1.5px solid var(--hm-border); background: var(--hm-card);
          transition: transform 0.25s, box-shadow 0.25s, border-color 0.25s;
          position: relative; overflow: hidden;
        }
        .hm-service-card::before {
          content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
          background: var(--hm-accent); transform: scaleX(0); transform-origin: left;
          transition: transform 0.3s;
        }
        .hm-service-card:hover {
          transform: translateY(-5px);
          box-shadow: var(--hm-shadow-hover);
          border-color: var(--hm-accent);
        }
        .hm-service-card:hover::before { transform: scaleX(1); }
        .hm-service-icon {
          width: 48px; height: 48px; border-radius: 10px; margin-bottom: 1rem;
          display: flex; align-items: center; justify-content: center;
          font-size: 1.2rem; color: var(--hm-primary);
          transition: transform 0.2s;
        }
        .hm-service-card:hover .hm-service-icon { transform: scale(1.1) rotate(-4deg); }
        .hm-service-card h5 {
          font-family: var(--font-display);
          font-size: 1rem; font-weight: 600;
          color: var(--hm-text-dark); margin-bottom: 0.6rem;
        }
        .hm-service-card p {
          font-family: var(--font-body);
          font-size: 0.875rem; color: var(--hm-text-body);
          line-height: 1.7; margin: 0; font-weight: 400;
        }

        /* ── SaaS dark section ── */
        .hm-saas { background: var(--hm-bg-dark); padding: 5rem 0; color: #fff; }
        .hm-saas .hm-eyebrow { color: var(--hm-cyan); }
        .hm-saas .hm-section-title { color: #fff; }
        .hm-saas-grid {
          display: grid; grid-template-columns: repeat(3,1fr);
          gap: 2rem; margin-top: 2.5rem;
        }
        .hm-saas-item { display: flex; align-items: flex-start; gap: 1rem; }
        .hm-saas-icon { color: var(--hm-cyan); font-size: 1.4rem; flex-shrink: 0; margin-top: 3px; }
        .hm-saas-item h5 {
          font-family: var(--font-display);
          font-size: 0.97rem; font-weight: 600;
          color: #fff; margin-bottom: 0.4rem;
        }
        .hm-saas-item p {
          font-family: var(--font-body);
          font-size: 0.85rem; color: rgba(255,255,255,0.65);
          line-height: 1.7; margin: 0; font-weight: 400;
        }

        /* ── Value pillars ── */
        .hm-pillars-grid {
          display: grid; grid-template-columns: repeat(4,1fr);
          gap: 1.25rem; margin-top: 2rem;
        }
        .hm-pillar-card {
          border-radius: 12px; border: 1.5px solid var(--hm-border);
          background: var(--hm-card); padding: 1.5rem 1.25rem; text-align: center;
          transition: transform 0.25s, box-shadow 0.25s;
        }
        .hm-pillar-card:hover { transform: translateY(-5px); box-shadow: var(--hm-shadow-hover); }
        .hm-pillar-img { width: 56px; height: 56px; object-fit: contain; margin-bottom: 0.85rem; }
        .hm-pillar-card h5 {
          font-family: var(--font-display);
          font-size: 0.95rem; font-weight: 600;
          color: var(--hm-text-dark); margin-bottom: 0.45rem;
        }
        .hm-pillar-card p {
          font-family: var(--font-body);
          font-size: 0.83rem; color: var(--hm-text-body);
          line-height: 1.65; margin: 0; font-weight: 400;
        }
        .hm-pillar-accent { color: var(--hm-accent); font-weight: 700; }

        /* ── Benefits ── */
        .hm-benefits-grid {
          display: grid; grid-template-columns: repeat(5,1fr);
          gap: 1.25rem; margin-top: 2rem;
        }
        .hm-benefit {
          border-top: 4px solid var(--hm-danger); padding-top: 1.1rem;
          transition: transform 0.2s;
        }
        .hm-benefit:hover { transform: translateY(-3px); }
        .hm-benefit h6 {
          font-family: var(--font-display);
          font-size: 0.9rem; font-weight: 600;
          color: var(--hm-primary); margin-bottom: 0.5rem;
        }
        .hm-benefit p {
          font-family: var(--font-body);
          font-size: 0.83rem; color: var(--hm-text-body);
          line-height: 1.65; margin: 0; font-weight: 400;
        }

        /* ── Belief band ── */
        .hm-belief {
          background: linear-gradient(135deg, #f0f4f9 0%, #e8eef6 100%);
          padding: 4rem 1.5rem; text-align: center;
          border-top: 1px solid var(--hm-border);
          border-bottom: 1px solid var(--hm-border);
        }
        .hm-belief p {
          font-family: var(--font-display);
          font-size: clamp(1.1rem, 2.5vw, 1.5rem);
          font-weight: 500; color: var(--hm-primary);
          max-width: 940px; margin: 0 auto;
          line-height: 1.6;
        }

        /* ── CTA banner ── */
        .hm-cta-banner {
          background: linear-gradient(135deg, #0d3c55 0%, #1a5c82 100%);
          padding: 3.5rem 1.5rem; text-align: center;
        }
        .hm-cta-banner h2 {
          font-family: var(--font-display);
          font-size: clamp(1.4rem, 3vw, 2rem);
          font-weight: 600; color: #fff; margin-bottom: 0.6rem;
        }
        .hm-cta-banner p {
          font-family: var(--font-body);
          font-size: 1rem; color: rgba(255,255,255,0.72); margin-bottom: 1.75rem;
          font-weight: 400;
        }
        .hm-btn-cta {
          display: inline-flex; align-items: center; gap: 0.5rem;
          padding: 0.8rem 1.75rem; background: var(--hm-accent2);
          color: #040e1e; border-radius: 8px; font-weight: 700;
          font-size: 0.95rem; text-decoration: none;
          font-family: var(--font-body); border: none; cursor: pointer;
          letter-spacing: 0.01em;
          transition: opacity 0.2s, box-shadow 0.25s, transform 0.2s;
        }
        .hm-btn-cta:hover {
          opacity: 0.88; color: #040e1e;
          box-shadow: 0 0 24px rgba(0,194,255,0.4); transform: translateY(-2px);
        }

        /* ── Certifications ── */
        .hm-certs {
          background: var(--hm-card); padding: 4rem 0;
          border-top: 1px solid var(--hm-border);
        }
        .hm-cert-box {
          position: relative; background: var(--hm-card);
          border: 1px solid var(--hm-border); border-radius: var(--hm-radius);
          box-shadow: var(--hm-shadow); padding: 2.5rem 2rem 1.5rem;
          display: flex; justify-content: center; align-items: center;
          flex-wrap: wrap; gap: 2rem; margin-top: 1rem;
        }
        .hm-cert-tab {
          position: absolute; top: -18px; left: 24px;
          background: #0072b1; color: #fff; padding: 0.4rem 1.25rem;
          border-radius: 8px; font-family: var(--font-body);
          font-weight: 600; font-size: 0.875rem;
          box-shadow: 0 4px 10px rgba(0,0,0,0.15);
        }
        .hm-cert-logo { object-fit: contain; max-height: 90px; width: auto; }

        /* ── Responsive ── */
        @media (max-width: 1024px) {
          .hm-services-grid,
          .hm-saas-grid     { grid-template-columns: repeat(2,1fr); }
          .hm-pillars-grid  { grid-template-columns: repeat(2,1fr); }
          .hm-benefits-grid { grid-template-columns: repeat(3,1fr); }
          .hm-int-grid      { grid-template-columns: repeat(2,1fr); }
        }
        @media (max-width: 640px) {
          .hm-section         { padding: 3rem 0; }
          .hm-services-grid,
          .hm-saas-grid,
          .hm-pillars-grid,
          .hm-int-grid        { grid-template-columns: 1fr; }
          .hm-benefits-grid   { grid-template-columns: repeat(2,1fr); }
          .hm-split.reverse   { flex-direction: column; }
          .hm-split-img img   { max-width: 100%; }
        }
        @media (max-width: 420px) {
          .hm-benefits-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="hm-page">

        {/* ── Hero Slider ── */}
        <Sliderhome />

        {/* ── Intro Strip ── */}
        <div className="hm-intro-strip">
          <div className="hm-container">
            <h2>Innovation through Digitalization, Automation, and Disruptive Technologies.</h2>
            <p>Comprehensive IT Consulting, Seamless System Integration, and End-to-End Application Development.</p>
          </div>
        </div>

        {/* ── Grow With Us ── */}
        <section className="hm-section">
          <div className="hm-container">
            <div className="hm-split">
              <div className="hm-split-img">
                <img src={Services18} alt={`Grow with ${COMPANY}`} loading="lazy" />
              </div>
              <div className="hm-split-text">
                <div className="hm-eyebrow">Careers</div>
                <h2 className="hm-section-title">Grow With Us</h2>
                <div className="hm-underline" />
                <p className="hm-section-desc" style={{ marginBottom: "1.75rem" }}>
                  Be part of global projects, innovate with cutting-edge technologies, and unlock
                  limitless career growth. We believe in a people-first approach — helping you
                  shape the future while building yours through global exposure, challenging
                  projects, and continuous learning.
                </p>
              </div>
            </div>
          </div>
        </section>

        <hr className="hm-divider" />

        {/* ── Purpose Band ── */}
        <div
          className="hm-purpose"
          style={{ backgroundImage: `url(${bgImage})` }}
          aria-label="Our Purpose"
        >
          <div className="hm-purpose-overlay" aria-hidden="true" />
          <div className="hm-purpose-inner">
            <h2>Our Purpose</h2>
            <p>
              To amplify human potential and create the next opportunity for people,
              businesses, and communities through technology-driven transformation.
            </p>
          </div>
        </div>

        {/* ── People & Technology ── */}
        <section className="hm-section" style={{ background: "#fff" }}>
          <div className="hm-container">
            <div className="hm-split">
              <div className="hm-split-text">
                <div className="hm-eyebrow">Our Approach</div>
                <h2 className="hm-section-title">People and Technology — Together, Driving Transformation.</h2>
                <div className="hm-underline" />
                <p className="hm-section-desc" style={{ marginBottom: "1.75rem" }}>
                  At the intersection of consulting, engineering, and technology, our experts enable
                  the world's most innovative enterprises to succeed in an AI-powered future. Our values
                  and expertise make us a trusted partner for transformative, lasting change.
                </p>
                <Link to="/service" className="hm-btn-primary">
                  Explore Our Offerings <FaArrowRight aria-hidden="true" />
                </Link>
              </div>
              <div className="hm-split-img">
                <img src={Services14} alt={`${COMPANY} — People and Technology`} loading="lazy" />
              </div>
            </div>
          </div>
        </section>

        {/* ── Advancing Industries ── */}
        <section className="hm-section">
          <div className="hm-container">
            <div className="hm-split reverse">
              <div className="hm-split-text">
                <div className="hm-eyebrow">Industry Focus</div>
                <h2 className="hm-section-title">Advancing Industries with Technology and Innovation</h2>
                <div className="hm-underline" />
                <p className="hm-section-desc" style={{ marginBottom: "1.75rem" }}>
                  Our consultants and engineers bring together industry insights, IT services
                  excellence, and AI-driven innovation to help businesses thrive — now and in
                  the future.
                </p>
                <Link to="/service" className="hm-btn-primary">
                  Explore Our Offerings <FaArrowRight aria-hidden="true" />
                </Link>
              </div>
              <div className="hm-split-img">
                <img src={Services15} alt={`Advancing industries with ${COMPANY}`} loading="lazy" />
              </div>
            </div>
          </div>
        </section>

        {/* ── Logistic component ── */}
        <Logistic />

        {/* ── Systems Integration ── */}
        <section className="hm-section" style={{ background: "#fff" }}>
          <div className="hm-container">
            <div className="hm-eyebrow">Integration</div>
            <h2 className="hm-section-title">Systems Integration</h2>
            <div className="hm-underline" />
            <p className="hm-section-desc">
              We provide Systems Integration services that streamline IT solutions, improve
              efficiency, ensure consistent data, and scale with your business — driving smarter
              decisions and cost efficiency.
            </p>
            <div className="hm-int-grid">
              {INTEGRATION_BENEFITS.map(({ id, icon, title }) => (
                <div key={id} className="hm-int-card">
                  <div className="hm-int-icon" aria-hidden="true">{icon}</div>
                  <h6>{title}</h6>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── VMC ── */}
        <VMC />

        {/* ── Belief Band ── */}
        <div className="hm-belief">
          <p>
            At the core of our belief is knowledge that delivers impact. With deep domain expertise
            and a people-first approach, we enable digital transformation that powers business success.
          </p>
        </div>

        {/* ── Smart Solutions / Services ── */}
        <section className="hm-section">
          <div className="hm-container">
            <div style={{ textAlign: "center", marginBottom: "1rem" }}>
              <div className="hm-eyebrow" style={{ display: "inline-block" }}>Our Services</div>
            </div>
            <h2 className="hm-section-title" style={{ textAlign: "center", margin: "0 auto 0.4rem" }}>
              Smart Solutions for Business Transformation &amp; Sustainable Growth.
            </h2>
            <div className="hm-underline" style={{ margin: "0 auto 1rem" }} />
            <p className="hm-section-desc" style={{ textAlign: "center", margin: "0 auto 0.25rem" }}>
              With cloud engineering and architecture expertise, we help organisations achieve
              scalable, cost-efficient, and future-ready transformation.
            </p>
            <div style={{ textAlign: "center", margin: "1.5rem 0 0" }}>
              <Link to="/contact" className="hm-btn-primary">
                Schedule a Free Consultation <FaArrowRight aria-hidden="true" />
              </Link>
            </div>
            <div className="hm-services-grid">
              {SERVICES.map(({ id, icon, title, desc, bg }) => (
                <div key={id} className="hm-service-card">
                  <div className="hm-service-icon" style={{ background: bg }} aria-hidden="true">{icon}</div>
                  <h5>{title}</h5>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── SaaS Section (dark) ── */}
        <section className="hm-saas">
          <div className="hm-container">
            <div className="hm-eyebrow">Solutions</div>
            <h2 className="hm-section-title">Comprehensive SaaS — Software as a Service includes</h2>
            <div className="hm-underline" />
            <div className="hm-saas-grid">
              {SAAS_ITEMS.map(({ id, icon, title, desc }) => (
                <div key={id} className="hm-saas-item">
                  <div className="hm-saas-icon" aria-hidden="true">{icon}</div>
                  <div>
                    <h5>{title}</h5>
                    <p>{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Value Pillars ── */}
        <section className="hm-section" style={{ background: "#fff" }}>
          <div className="hm-container">
            <div className="hm-eyebrow">Why Choose Us</div>
            <h2 className="hm-section-title">What Sets Us Apart</h2>
            <div className="hm-underline" />
            <div className="hm-pillars-grid">
              {VALUE_PILLARS.map(({ id, img, title, accentWord, desc }) => (
                <div key={id} className="hm-pillar-card">
                  <img src={img} alt={`${title} ${accentWord}`} className="hm-pillar-img" loading="lazy" />
                  <h5>
                    {title} <span className="hm-pillar-accent">{accentWord}</span>
                  </h5>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── SaaS Benefits ── */}
        <section className="hm-section">
          <div className="hm-container">
            <div style={{ textAlign: "center", marginBottom: "0.3rem" }}>
              <div className="hm-eyebrow" style={{ display: "inline-block" }}>Benefits</div>
            </div>
            <h2 className="hm-section-title" style={{ textAlign: "center", margin: "0 auto 2rem", maxWidth: 760 }}>
              Our SaaS solutions provide a unique range of business benefits
            </h2>
            <div className="hm-benefits-grid">
              {SAAS_BENEFITS.map(({ id, title, desc }) => (
                <div key={id} className="hm-benefit">
                  <h6>{title}</h6>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── CTA Banner ── */}
        <div className="hm-cta-banner">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let's discuss how {COMPANY} can accelerate your digital journey.</p>
          <Link to="/contact" className="hm-btn-cta">
            Get in Touch <FaArrowRight aria-hidden="true" />
          </Link>
        </div>

        {/* ── Certifications ── */}
        <section className="hm-certs">
          <div className="hm-container" style={{ textAlign: "center" }}>
            <div className="hm-eyebrow" style={{ display: "inline-block" }}>Trust &amp; Compliance</div>
            <h2 className="hm-section-title" style={{ marginTop: "0.3rem" }}>Our Certifications</h2>
            <div className="hm-cert-box" style={{ maxWidth: 680, margin: "1.5rem auto 0" }}>
              <div className="hm-cert-tab">Certified &amp; Compliant</div>
              {CERTS.map(({ id, src, alt, maxH }) => (
                <img key={id} src={src} alt={alt} className="hm-cert-logo" style={{ maxHeight: maxH }} loading="lazy" />
              ))}
            </div>
          </div>
        </section>

        {/* ── WhatsApp widget ── */}
        <WhatsApp />
      </div>
    </>
  );
}

export default Home;